import { render, staticRenderFns } from "./ApriaSitiosRamsar.vue?vue&type=template&id=6a283430&lang=pug"
import script from "./ApriaSitiosRamsar.vue?vue&type=script&lang=js"
export * from "./ApriaSitiosRamsar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports